<div class="modify-desktop-skeleton-mach-core">
  <!-- Desktop: 992px - 1439px -->
  <div class="flex flex-col gap-24 ultrawide:hidden">
    <!-- Flights Input Section -->
    <div class="flex gap-24 items-center w-full">
      <div class="flex gap-8 flex-1">
        <!-- From/To Input -->
        <div
          class="skeleton rounded-02 h-[74px] flex-[266]"
          role="progressbar"
          aria-label="Loading departure and arrival cities"
        ></div>
        <!-- Departure Date -->
        <div
          class="skeleton rounded-02 h-[74px] flex-[195.5]"
          role="progressbar"
          aria-label="Loading departure date"
        ></div>
        <!-- Return Date -->
        <div
          class="skeleton rounded-02 h-[74px] flex-[195.5]"
          role="progressbar"
          aria-label="Loading return date"
        ></div>
        <!-- Passengers -->
        <div
          class="skeleton rounded-02 h-[74px] flex-[91]"
          role="progressbar"
          aria-label="Loading passenger count"
        ></div>
      </div>
      <!-- Search Button -->
      <div
        class="skeleton rounded-02 h-16 w-[132px] mt-[5px]"
        role="progressbar"
        aria-label="Loading search button"
      ></div>
    </div>

    <!-- Modifiers Section - Checkboxes -->
    <div class="flex flex-col gap-24">
      <!-- First Row: 3 Checkboxes + Advanced Search Link -->
      <div class="flex items-center justify-between">
        <div class="flex gap-32">
          <!-- Checkbox 1 -->
          <div class="flex items-center gap-12">
            <div
              class="skeleton size-6 rounded-01"
              role="progressbar"
              aria-label="Loading checkbox"
            ></div>
            <div
              class="skeleton rounded-01 h-6 w-[108px]"
              role="progressbar"
              aria-label="Loading label"
            ></div>
          </div>
          <!-- Checkbox 2 -->
          <div class="flex items-center gap-12">
            <div
              class="skeleton size-6 rounded-01"
              role="progressbar"
              aria-label="Loading checkbox"
            ></div>
            <div
              class="skeleton rounded-01 h-6 w-[145px]"
              role="progressbar"
              aria-label="Loading label"
            ></div>
          </div>
          <!-- Checkbox 3 -->
          <div class="flex items-center gap-12">
            <div
              class="skeleton size-6 rounded-01"
              role="progressbar"
              aria-label="Loading checkbox"
            ></div>
            <div
              class="skeleton rounded-01 h-6 w-[130px]"
              role="progressbar"
              aria-label="Loading label"
            ></div>
          </div>
        </div>
        <!-- Advanced Search Link -->
        <div
          class="skeleton rounded-01 h-5 w-[141px]"
          role="progressbar"
          aria-label="Loading advanced search"
        ></div>
      </div>

      <!-- Second Row: Checkbox 4 only -->
      <div class="flex items-center gap-12">
        <div
          class="skeleton size-6 rounded-01"
          role="progressbar"
          aria-label="Loading checkbox"
        ></div>
        <div
          class="skeleton rounded-01 h-6 w-[176px]"
          role="progressbar"
          aria-label="Loading label"
        ></div>
      </div>
    </div>

    <!-- Additional Search Inputs (Row 3) -->
    <div class="flex gap-12 items-center justify-between">
      <div class="flex gap-12 items-center">
        <!-- Dropdown 1 -->
        <div
          class="skeleton rounded-02 h-16 w-[278.67px]"
          role="progressbar"
          aria-label="Loading dropdown"
        ></div>
        <!-- Dropdown 2 -->
        <div
          class="skeleton rounded-02 h-16 w-[278.67px]"
          role="progressbar"
          aria-label="Loading dropdown"
        ></div>
      </div>
      <!-- Link -->
      <div
        class="skeleton rounded-01 h-5 w-[326.66px]"
        role="progressbar"
        aria-label="Loading link"
      ></div>
    </div>
  </div>

  <!-- Desktop Large: 1440px and above -->
  <div class="hidden ultrawide:flex flex-col gap-24">
    <!-- Flights Input Section -->
    <div class="flex gap-32 items-center w-full">
      <div class="flex gap-12 flex-1">
        <!-- From/To Input -->
        <div
          class="skeleton rounded-02 h-[74px] flex-[292]"
          role="progressbar"
          aria-label="Loading departure and arrival cities"
        ></div>
        <!-- Departure Date -->
        <div
          class="skeleton rounded-02 h-[74px] flex-[272]"
          role="progressbar"
          aria-label="Loading departure date"
        ></div>
        <!-- Return Date -->
        <div
          class="skeleton rounded-02 h-[74px] flex-[271]"
          role="progressbar"
          aria-label="Loading return date"
        ></div>
        <!-- Passengers -->
        <div
          class="skeleton rounded-02 h-[74px] flex-[95]"
          role="progressbar"
          aria-label="Loading passenger count"
        ></div>
      </div>
      <!-- Search Button -->
      <div
        class="skeleton rounded-02 h-16 w-[154px] mt-[5px]"
        role="progressbar"
        aria-label="Loading search button"
      ></div>
    </div>

    <!-- Modifiers Section - Single Row -->
    <div class="flex items-center justify-between">
      <div class="flex gap-32">
        <!-- Checkbox 1 -->
        <div class="flex items-center gap-12">
          <div
            class="skeleton size-6 rounded-01"
            role="progressbar"
            aria-label="Loading checkbox"
          ></div>
          <div
            class="skeleton rounded-01 h-6 w-[108px]"
            role="progressbar"
            aria-label="Loading label"
          ></div>
        </div>
        <!-- Checkbox 2 -->
        <div class="flex items-center gap-12">
          <div
            class="skeleton size-6 rounded-01"
            role="progressbar"
            aria-label="Loading checkbox"
          ></div>
          <div
            class="skeleton rounded-01 h-6 w-[145px]"
            role="progressbar"
            aria-label="Loading label"
          ></div>
        </div>
        <!-- Checkbox 3 -->
        <div class="flex items-center gap-12">
          <div
            class="skeleton size-6 rounded-01"
            role="progressbar"
            aria-label="Loading checkbox"
          ></div>
          <div
            class="skeleton rounded-01 h-6 w-[130px]"
            role="progressbar"
            aria-label="Loading label"
          ></div>
        </div>
        <!-- Checkbox 4 -->
        <div class="flex items-center gap-12">
          <div
            class="skeleton size-6 rounded-01"
            role="progressbar"
            aria-label="Loading checkbox"
          ></div>
          <div
            class="skeleton rounded-01 h-6 w-[176px]"
            role="progressbar"
            aria-label="Loading label"
          ></div>
        </div>
      </div>
      <!-- Advanced Search Link -->
      <div
        class="skeleton rounded-01 h-5 w-[141px]"
        role="progressbar"
        aria-label="Loading advanced search"
      ></div>
    </div>

    <!-- Additional Search Inputs -->
    <div class="flex gap-12 items-center justify-between">
      <div class="flex gap-12 items-center">
        <!-- Checkbox with label -->
        <div class="flex items-center gap-12">
          <div
            class="skeleton size-6 rounded-01"
            role="progressbar"
            aria-label="Loading checkbox"
          ></div>
          <div
            class="skeleton rounded-01 h-6 w-[162px]"
            role="progressbar"
            aria-label="Loading label"
          ></div>
        </div>
        <!-- Dropdown 1 -->
        <div
          class="skeleton rounded-02 h-16 w-[278.67px]"
          role="progressbar"
          aria-label="Loading dropdown"
        ></div>
        <!-- Dropdown 2 -->
        <div
          class="skeleton rounded-02 h-16 w-[278.67px]"
          role="progressbar"
          aria-label="Loading dropdown"
        ></div>
      </div>
      <!-- Link -->
      <div
        class="skeleton rounded-01 h-5 w-[320.66px]"
        role="progressbar"
        aria-label="Loading link"
      ></div>
    </div>
  </div>
</div>
